<template lang="pug">
.guide
  .guide-kv
    .guide-kv-image
      img.guide-kv-img(src="/static/images/manual/guide_kv.webp")
    .guide-kv-underWrapper
      .guide-kv-parallelBox
        .guide-kv-parallelBox-sidePanel
        .guide-kv-parallelBox-articleMainContents
          h2.guide-kv-parallelBox-articleMainContents-text 商圏の求人動向分析
  .guide-breadcrumb(v-for="page in pages")
    .guide-breadcrumb-child
      a.guide-breadcrumb-child-link(:href="page.indexLink") 市況分析
      p.guide-breadcrumb-child-slach &nbsp;/&nbsp;
      p.guide-breadcrumb-child-current 集計から省きたい企業を登録する
  .guide-parallelBox
    .guide-sidePanel
      dl.guide-sidePanel-inner(v-for="list in sideContents")
        dt.guide-sidePanel-section
          .guide-sidePanel-section-title {{ list.sidePanelSection }}
          dd.guide-sidePanel-article(v-for="title in list.articleList")
            a.guide-sidePanel-article-link(:href="title.articlelink" :class="{ '-isCurrent': title.isCurrent}" v-if="title.isTwoLine")
              span.guide-sidePanel-article-link-oneLine {{ title.articleTextOneLine }}
              br
              span.guide-sidePanel-article-link-twoLine {{ title.articleTextTwoLine }}
            a.guide-sidePanel-article-link(:href="title.articlelink" :class="{ '-isCurrent': title.isCurrent}" v-else) {{ title.articleText }}

    .guide-articleMainContents
      .guide-articleMainContents-inner
        .guide-articleMainContents-headLineWrap
            h3.guide-articleMainContents-headLineWrap-headLine 集計から省きたい企業を登録する
        .guide-articleMainContents-contents
          p.guide-articleMainContents-textDetail
            | 市況分析機能には「除外企業管理」の機能も適用することができるため、特定の企業の求人を集計対象から省くことも可能です。
            br
            | 例えば、自社商圏内で競合の人材派遣会社等が大量に求人を出している場合に、除外企業管理を活用して人材派遣系の企業を集計対象から除外し、自社商圏内の事業会社のみの求人数推移を確認することができるようになります。
          .guide-articleMainContents-image(v-if="identifier () === 'kobot'")
            img.guide-articleMainContents-image-img(src="/static/images/manual/market-analysis/kobot/guide_2c_01.webp")
          .guide-articleMainContents-image(v-else-if="identifier () === 'mynavi'")
            img.guide-articleMainContents-image-img(src="/static/images/manual/market-analysis/mynavi/guide_2c_01.webp")
          .guide-articleMainContents-image(v-else)
            img.guide-articleMainContents-image-img(src="/static/images/manual/market-analysis/guide_2c_01.webp")
          p.guide-articleMainContents-textOnly 「除外企業管理」は右上のアカウント名をクリックして開くメニューの中にあります。
          .guide-articleMainContents-image(v-if="identifier () === 'kobot'")
            img.guide-articleMainContents-image-img(src="/static/images/manual/market-analysis/kobot/guide_2c_02.webp")
          .guide-articleMainContents-image(v-else-if="identifier () === 'mynavi'")
            img.guide-articleMainContents-image-img(src="/static/images/manual/market-analysis/mynavi/guide_2c_02.webp")
          .guide-articleMainContents-image(v-else)
            img.guide-articleMainContents-image-img(src="/static/images/manual/market-analysis/guide_2c_02.webp")
          p.guide-articleMainContents-textOnly ページが切り替わったら、画面の中央にあるテキストボックスに、除外したい会社名を1行につき1社ずつ登録しましょう。1アカウントにつき、最大1,000社まで登録することができます。
          .guide-articleMainContents-image(v-if="identifier () === 'kobot'")
            img.guide-articleMainContents-image-img(src="/static/images/manual/market-analysis/kobot/guide_2c_03.webp")
          .guide-articleMainContents-image(v-else-if="identifier () === 'mynavi'")
            img.guide-articleMainContents-image-img(src="/static/images/manual/market-analysis/mynavi/guide_2c_03.webp")
          .guide-articleMainContents-image(v-else)
            img.guide-articleMainContents-image-img(src="/static/images/manual/market-analysis/guide_2c_03.webp")
          p.guide-articleMainContents-textOnly
            | 入力し終わったら、テキストボックス下の「上記の企業を検索対象から除外する」部分をクリックして「ON」に切り替えて、「更新する」ボタンをクリックすることで、設定が完了します。
            br
            | ここが「ON」になっているときは、「市況分析」と「求人検索」の両方のメニューで、登録されている企業の求人が除外されるようになりますのでご注意ください。

      .guide-articleMainContents-movePage(v-for="page in pages")
        a.guide-articleMainContents-movePage-container.-pageBack(:href="page.backLink")
          .guide-articleMainContents-movePage-container-outer
            .guide-articleMainContents-movePage-container-inner
              .guide-articleMainContents-movePage-container-textArea
                p.guide-articleMainContents-movePage-container-title {{ page.backPageTitle }}
                p.guide-articleMainContents-movePage-container-text {{ page.backPageText }}
              .guide-articleMainContents-movePage-container-image
                img.guide-articleMainContents-movePage-container-img(src="/static/images/manual/guide_icon_arrow.svg")
        a.guide-articleMainContents-movePage-pageIndex(:href="page.indexLink")
          .guide-articleMainContents-movePage-pageIndex-outer
            .guide-articleMainContents-movePage-pageIndex-inner
              .guide-articleMainContents-movePage-pageIndex-image
                img.guide-articleMainContents-movePage-pageIndex-img(src="/static/images/manual/guide_icon_index.svg")
              p.guide-articleMainContents-movePage-pageIndex-title 市況分析一覧
        a.guide-articleMainContents-movePage-container.-pageNext(:href="page.nextLink")
          .guide-articleMainContents-movePage-container-outer
            .guide-articleMainContents-movePage-container-inner
              .guide-articleMainContents-movePage-container-textArea
                p.guide-articleMainContents-movePage-container-title {{ page.nextPageTitle }}
                p.guide-articleMainContents-movePage-container-text
                  span.guide-articleMainContents-movePage-container-text-oneLine {{ page.nextPageTextOneLine }}
                  br
                  span.guide-articleMainContents-movePage-container-text-twoLine {{ page.nextPageTextTwoLine }}
              .guide-articleMainContents-movePage-container-image
                img.guide-articleMainContents-movePage-container-img(src="/static/images/manual/guide_icon_arrow.svg")
</template>

<script>
export default {
  data () {
    return {
      job_notification_settings: '',
      headLineTitle: '',
      textOnly: '',
      image: '',
      titleTextTitle: '',
      titleTextText: '',
      isCurrent: '',
      sideContents: [
        {
          sidePanelSection: '1. 基本的な操作方法',
          articleList: [
            {
              articlelink: '/guide/market_analysis/1-a',
              articleText: 'a. 市況分析機能の概要',
            },
            {
              articlelink: '/guide/market_analysis/1-b',
              articleText: 'b. 集計の目的と集計対象を決める',
            },
            {
              articlelink: '/guide/market_analysis/1-c',
              articleText: 'c. 集計に使う求人を指定する',
            },
            {
              articlelink: '/guide/market_analysis/1-d',
              articleText: 'd. 集計した条件を保存する',
            },
            {
              articlelink: '/guide/market_analysis/1-e',
              articleText: 'e. 集計した値をDLする',
            },
          ],
        },
        {
          sidePanelSection: '2. 商圏の求人動向分析',
          articleList: [
            {
              articlelink: '/guide/market_analysis/2-a',
              articleText: 'a. 活用のイメージ',
            },
            {
              articlelink: '/guide/market_analysis/2-b',
              articleText: 'b. ターゲット領域を決める',
            },
            {
              isCurrent: true,
              articlelink: '/guide/market_analysis/2-c',
              articleText: 'c. 集計から省きたい企業を登録する',
            },
            {
              isTwoLine: true,
              articlelink: '/guide/market_analysis/2-d',
              articleTextOneLine: 'd. 集計に使う条件を指定して',
              articleTextTwoLine: '条件を保存する',
            },
          ],
        },
        {
          sidePanelSection: '3. 特定企業の分析',
          articleList: [
            {
              articlelink: '/guide/market_analysis/3-a',
              articleText: 'a. 活用のイメージ',
            },
            {
              articlelink: '/guide/market_analysis/3-b',
              articleText: 'b. ターゲットを明確にする',
            },
            {
              articlelink: '/guide/market_analysis/3-c',
              articleText: 'c. 集計したい企業を登録する',
            },
            {
              articlelink: '/guide/market_analysis/3-d',
              articleText: 'd. 集計から省きたい企業を登録する',
            },
            {
              isTwoLine: true,
              articlelink: '/guide/market_analysis/3-e',
              articleTextOneLine: 'e. 集計に使う条件を指定して',
              articleTextTwoLine: '条件を保存する',
            },
          ],
        },
      ],

      pages: [
        {
          backLink: '/guide/market_analysis/2-b',
          backPageTitle: '2. 商圏の求人動向分析',
          backPageText: 'b. ターゲット領域を決める',
          indexLink: '/guide/market_analysis',
          nextLink: '/guide/market_analysis/2-d',
          nextPageTitle: '2. 商圏の求人動向分析',
          nextPageTextOneLine: 'd. 集計に使う条件を指定して',
          nextPageTextTwoLine: '条件を保存する',
        },
      ],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/guide/market-analysis/overview/2-c.vue